import isEmail from 'validator/es/lib/isEmail';

import {
  CLASS_BOOST_SD_BIS_EMAIL_INPUT_ERROR,
  CLASS_BOOST_SD_BIS_SUBMIT_BUTTON_ACTIVE,
  EMAIL_ERROR_MESSAGE,
} from '../constants';

/**
 * @type {import('../index.d').handleEmailValidation}
 */
export function handleEmailValidation(emailInput, errorMessageElement, submitButton) {
  const validation = isEmail(emailInput.value);

  if (errorMessageElement) {
    if (!validation) {
      errorMessageElement.textContent = EMAIL_ERROR_MESSAGE;
      errorMessageElement.style.display = 'block';
      emailInput.classList.add(CLASS_BOOST_SD_BIS_EMAIL_INPUT_ERROR);
    } else {
      errorMessageElement.style.display = 'none';
      emailInput.classList.remove(CLASS_BOOST_SD_BIS_EMAIL_INPUT_ERROR);
    }
  } else {
    console.error('Error message element not found.');
  }

  if (submitButton) {
    submitButton.disabled = !validation;
    submitButton.setAttribute('aria-disabled', !validation);
    submitButton.classList.toggle(CLASS_BOOST_SD_BIS_SUBMIT_BUTTON_ACTIVE, validation);
  } else {
    console.error('Submit button not found.');
  }
}
